module.exports = __webpack_public_path__ + "media/typy/dostawcze@3x-7f4a9e2f.svg";